import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const {addData} = useEntityCrud('Discount/SetDiscount');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        maxDiscount: '',
        discountPercentage: '',
        businessId: 0,
        groupId: 0,
        serviceId: 0,
        subServiceId: 0,
        branchId: 0,
        roleId: 0,
        personId: []
    };
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required(),
        discountPercentage: Yup.number()
        .min(1)
        .max(100)
        .required(),
        maxDiscount: Yup.string()
        .required(),
        businessId: Yup.string()
        .required(),
        groupId: Yup.string()
        .required(),
        serviceId: Yup.string()
        .required(),
        subServiceId: Yup.string()
        .required(),
        branchId: Yup.string()
        .required(),
        personId: Yup.array()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        let personIds = [];
        values.personId.map(person => {
            personIds.push(person.value);
        })
        const postedData = {
            title: values.title,
            maxDiscount: values.maxDiscount,
            discountCode: '',
            discountPercentage: values.discountPercentage,
            subServiceId: values.subServiceId,
            subServiceTitle: '',
            branchId: values.branchId,
            branchTitle: '',
            personId: personIds
        };
        addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('کد تخفیف جدید با موفقیت ایجاد شد');
                return navigate('/discounts');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/discounts',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد کد تخفیف جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;